

const Account = () => {

   return (
      <>
         <h1>Account page</h1>
         <p>Content goes here</p>
      </>
   )
}

export default Account;